import { PageHeader, StateKit } from '@statura/ui';

const ENABLEMENT_GUIDANCE =
  'Ask your organisation administrator to arrange for Medications to be enabled for your care programme.';

/** A confirmed module refusal says nothing about whether medication records exist. */
export function MedicationModuleNotEnabled({
  title,
  clinicalContext = false,
}: {
  title?: string;
  clinicalContext?: boolean;
}) {
  return (
    <div className="min-w-0 space-y-6" role="status">
      {title ? <PageHeader title={title} /> : null}
      <StateKit
        state="denied"
        title="Medications isn't turned on for your organisation"
        description={
          clinicalContext
            ? `The full Medications workspace is off. Current medication orders remain available read-only in Clinical context. ${ENABLEMENT_GUIDANCE}`
            : `Medication records may already exist. They are not shown while this module is off. ${ENABLEMENT_GUIDANCE} For current care, use your provider's authorised medicines record and contact the responsible clinician.`
        }
      />
    </div>
  );
}
